import { faker } from '@faker-js/faker';
import { ChevronLeft } from '@mui/icons-material';
import {
  Box,
  Button,
  IconButton,
  useTheme
} from '@mui/material';
import { DateTime } from 'luxon';
import { CustomIcon } from 'modules/components/layer00';
import { DocumentPaneCard } from 'modules/components/layer05';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';



export type PlanDocumentPaneProps = {
  expanded: boolean;
  showDetail: React.Dispatch<React.SetStateAction<boolean>>;
  width: string;
  documents: DocumentPaneCard.DocumentPaneCardProps[];
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PlanDocumentPaneProps) => {
  const theme = useTheme();

  if (props.expanded) {
    return (
      <Box
        position='fixed'
        bgcolor={theme.palette.background.default}
        width={props.width}
        height='20%'
        bottom={0}
        left={0}
      >
        <Box
          position='relative'
          marginX='1.5rem'
          height='100%'
          marginY='0rem'
        >
          {/* CAROLSEL */}
          <Box
            component='div'
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row',
              height: '90%',
              margin: 0,
              padding: 0,
              overflow: 'hidden',
              columnGap: '1rem',
              overflowX: 'auto',
              scrollSnapType: 'x mandatory',
              scrollBehavior: 'smooth',
              scrollbarWidth: 'none'
            }}
          >
            <ChevronLeft />
            {props.documents.map((node, i) => (
              <>
                <DocumentPaneCard.FC
                  {...node}
                  key={`${node.id}-${i}`}
                />
              </>
            ))}


            <IconButton
              onClick={() => props.showDetail(() => false)}
              color='primary'
              sx={{
                position: 'absolute',
                right: -20,
                top: 0
              }}
            >
              <CustomIcon.large.FC
                icon='CLOSE'
                stroke={theme.palette.primary.main}
              />
            </IconButton>


          </Box>
        </Box>
      </Box>
    );
  }
  return (
    <Box
      position='fixed'
      left={120}
      bottom={40}
      width='10rem'
      height='40px'
      zIndex={1000}
      onClick={() => {
        props.showDetail(() => true);
      }}
    >
      <Button
        variant='contained'
        color='primary'
      >
        Files
      </Button>
    </Box>
  );
};
